import { Component, Input } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { Globals } from "../../../../../globals";
import { HttpClient } from '@angular/common/http';

@Component({
    selector: 'page-combo-create-partial-description',
    templateUrl: 'combo-create-partial-description.html',
})
export class ComboCreatePartialDescriptionPage {
    @Input() form;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public http: HttpClient,
        public alertCtrl: AlertController) {
    }

}



// WEBPACK FOOTER //
// ./src/pages/combo/combo-create/combo-create-title/combo-create-partial-description/combo-create-partial-description.ts